/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/microphone'
export default icon
